<script>
  import { ArrowUp, ArrowDown, CornerDownLeft } from 'lucide-svelte'

  // Props
  let { list, open = $bindable(false) } = $props()
</script>

<!-- The footer -->
<div class="flex items-center justify-between px-5 py-4 bg-stone-100/60 rounded-b-xl border-t border-stone-200/80">
        
  <!-- The left buttons -->
  <div class="flex items-center gap-8">
    
    <!-- Up/down icons and label -->
     <div class="flex items-center gap-1 mr-3">
      <button type="button" disabled={!list.highlighted} class="flex items-center justify-center border border-stone-200 bg-stone-50 text-stone-400 p-[0.25rem] hover:text-gray-800 h-[26px] w-[26px]" onclick={list.up}>
        <ArrowUp size={16} strokeWidth={2.5} />
      </button>
      <button type="button" disabled={!list.highlighted} class="flex items-center justify-center border border-stone-200 bg-stone-50 text-stone-400 p-[0.25rem] hover:text-gray-800 h-[26px] w-[26px]" onclick={list.down}>
        <ArrowDown size={16} strokeWidth={2.5} />
      </button>
      <span class="text-[14px] tracking-wide text-stone-400 ml-2 leading-none">Naviguer</span>
    </div>


    <!-- Enter button and label -->
    <button type="button" disabled={!list.highlighted} class="flex items-center gap-1 flex-1 hover:*:text-gray-800" onclick={list.enter}>
      <div class="flex items-center justify-center border border-stone-200 bg-stone-50 text-stone-400 p-[0.25rem] h-[26px] w-[26px]">
        <CornerDownLeft size={16} strokeWidth={2.5} />
      </div>
      <span class="text-[14px] tracking-wide text-stone-400 ml-2 leading-none">Sélectionner</span>
    </button>

  </div>

  <!-- The right buttons -->
   <div class="flex items-center gap-8">
  
    <!-- Settings dropdown -->
    <!-- <SettingsDropdown /> -->

    <!-- Escape button and label -->
    <button type="button" class="flex items-center gap-1 hover:*:text-gray-800" onclick={() => open = false}>
      <span class="text-[14px] tracking-wide text-stone-400 mr-2 leading-none">Fermer</span>
      <div class="flex items-center justify-center border border-stone-200 bg-stone-50 text-stone-400 p-[0.25rem] text-[11px] h-[26px] min-w-[26px] leading-none">esc</div>
    </button>

  </div>
   
</div>